import { useContext } from "react";
import { useState } from "react";
import SearchField from "../components/admin/support/SearchField";
import TopNavigation from "../components/navigation/TopNavigation";
import ViewHeader from "../components/UiComponents/ViewHeader";
import UserContext from "../hooks/UserContext";
import CustomerSuccessTable from "../components/admin/customerSuccess/CustomerSuccessTable";
import styled from "styled-components";

const Container = styled.div`
    margin: 0 10px;
`

const CustomerUseView = props => {
    const user = useContext(UserContext);
    const [searchValue, setSearchValue] = useState('');

    const searchHandler = (value) => {
        setSearchValue(value)
    }

    if (user.user.role === 'admin' || user.user.role === 'impersonator') {
        return <>
            <ViewHeader fitToSmallScreen={true}>
                <TopNavigation to={'/supportcenter'} />
                <h3>Customer Use</h3>
            </ViewHeader>

            <Container>
                <SearchField value={searchValue} onChange={searchHandler} />

                <CustomerSuccessTable searchValue={searchValue} setCustomer={props.setCustomer} />
            </Container>

        </>
    } else {
        return <></>
    }
}

export default CustomerUseView;